import './footer.css';

const Footer = () => (
  <footer className="footer">
    <p className="footer_text">
      Copyright &copy; 2022 | Designed by&nbsp;
      <span>Jonathan MUNAMIRE</span>
    </p>
  </footer>
);

export default Footer;
